import React from 'react'
import HomeHeroSection from '../../sections/HomeHeroSection/HomeHeroSection'
import HomeSection from '../../sections/HomeSection/HomeSection'
import FoodGalleryCarousell from '../../sections/FoodGalleryCarousell/FoodGalleryCarousell'
import HomeLocationSection from '../../sections/HomeLocationSection/HomeLocationSection'
import ReservationSection from '../../sections/ReservationSection/ReservationSection'

const HomePage = () => {
  return (
    <div >
        <HomeHeroSection/>
        <HomeSection/>
        <FoodGalleryCarousell/>
        <HomeLocationSection/>
        <ReservationSection/>
    </div>
  )
}

export default HomePage